<template lang="pug">
.input-text
  label.input-text__label(for="field-login-email") E-mail *
  input.input-text__input(
    id="field-login-email"
    type="email"
    placeholder=""
    v-model.trim="value"
    @change="changeFieldValue()"
    @keyup="changeFieldValue()"
  )
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'FieldEmail',

  data () {
    return {
      value: ''
    }
  },

  methods: {
    ...mapMutations([
      'changeField'
    ]),

    changeFieldValue () {
      this.changeField({
        name: 'fieldEmail',
        value: this.value
      })
    }
  }
}
</script>
